import {
  TrendingUp,
  Building2,
  Globe2,
  Briefcase,
  Shield,
  Users2,
  Lock,
  PieChart,
  MapPin,
  FileText,
  ArrowRight,
  CheckCircle
} from "lucide-react";

export default function HNIFamilyOfficeAdvisory() {
  const sections = [
    {
      id: "wealth-management",
      title: "Wealth Management & Private Client Advisory",
      icon: TrendingUp,
      heroImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80",
      subsections: [
        {
          icon: PieChart,
          title: "Comprehensive Wealth Advisory",
          description: "Holistic wealth planning and portfolio management",
          points: [
            "Holistic wealth assessment and financial goal planning",
            "Asset allocation and portfolio structuring advisory",
            "Risk profiling and investment suitability assessment",
            "Periodic portfolio review and rebalancing advisory",
            "Liquidity planning and cash flow optimization"
          ],
          image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
        },
        {
          icon: TrendingUp,
          title: "Investment & Capital Markets Advisory",
          description: "Expert guidance across diverse asset classes",
          points: [
            "Advisory on equities, fixed income, mutual funds, PMS, AIFs, and alternative investments",
            "Structured products and bespoke investment solutions advisory",
            "Real estate and private equity investment advisory",
            "ESG and impact investment advisory",
            "Global investment diversification advisory"
          ],
          image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80"
        },
        {
          icon: Users2,
          title: "Succession, Estate & Legacy Planning",
          description: "Preserving and transferring wealth across generations",
          points: [
            "Succession and inheritance planning advisory",
            "Trust, will, and estate structuring (in coordination with legal advisors)",
            "Family governance and wealth transition frameworks",
            "Next-generation education and stewardship advisory"
          ],
          image: "https://images.unsplash.com/photo-1554224154-22dec7ec8818?w=800&q=80"
        }
      ]
    },
    {
      id: "family-office",
      title: "Family Office Setup & Management Advisory",
      icon: Building2,
      heroImage: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?w=1200&q=80",
      subsections: [
        {
          icon: Building2,
          title: "Family Office Structuring",
          description: "Designing and implementing family office structures",
          points: [
            "Advisory on single-family and multi-family office models",
            "Legal and tax-efficient structuring of family offices",
            "Operating model design and governance frameworks",
            "Investment policy statement (IPS) formulation",
            "Cost and performance benchmarking"
          ],
          image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80"
        },
        {
          icon: FileText,
          title: "Ongoing Family Office Advisory",
          description: "Continuous support for family office operations",
          points: [
            "Oversight of investment managers and service providers",
            "Consolidated reporting and MIS advisory",
            "Risk management and compliance oversight",
            "Philanthropy and impact investing advisory",
            "Lifestyle asset and special situation advisory"
          ],
          image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80"
        }
      ]
    },
    {
      id: "overseas-setup",
      title: "Overseas Office & Company Setup Advisory",
      icon: Globe2,
      heroImage: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=1200&q=80",
      subsections: [
        {
          icon: MapPin,
          title: "Jurisdiction Selection & Structuring",
          description: "Strategic selection of optimal overseas jurisdictions",
          points: [
            "Advisory on selection of optimal overseas jurisdictions",
            "Comparative analysis of regulatory, tax, and business environments",
            "Cross-border holding and operating structure advisory",
            "Substance, residency, and economic presence planning"
          ],
          image: "https://images.unsplash.com/photo-1569025690938-a00729c9e1f9?w=800&q=80"
        },
        {
          icon: Building2,
          title: "Overseas Company Incorporation & Office Setup",
          description: "End-to-end support for international expansion",
          points: [
            "End-to-end advisory for overseas company incorporation",
            "Branch, subsidiary, and representative office setup advisory",
            "Coordination with local legal, corporate secretarial, and tax advisors",
            "Assistance with licenses, registrations, and local compliance"
          ],
          image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
        }
      ]
    },
    {
      id: "overseas-banking",
      title: "Overseas Bank Account Opening Advisory",
      icon: Briefcase,
      heroImage: "https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=1200&q=80",
      subsections: [
        {
          icon: Briefcase,
          title: "Banking & Financial Infrastructure Advisory",
          description: "Strategic banking partner selection and setup",
          points: [
            "Advisory on selection of international banks and financial institutions",
            "Guidance on account types (corporate, trust, investment, escrow)",
            "Documentation and KYC/AML readiness assessment",
            "Coordination with banks and relationship managers"
          ],
          image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80"
        },
        {
          icon: CheckCircle,
          title: "Account Opening Procedure & Compliance",
          description: "Seamless account opening and regulatory compliance",
          points: [
            "Step-by-step advisory on overseas bank account opening procedures",
            "Support with preparation and review of application documentation",
            "Advisory on source-of-funds and source-of-wealth disclosures",
            "Assistance with regulatory reporting and ongoing compliance requirements"
          ],
          image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80"
        }
      ]
    },
    {
      id: "cross-border-tax",
      title: "Cross-Border Tax & Regulatory Advisory",
      icon: Shield,
      heroImage: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=1200&q=80",
      subsections: [
        {
          icon: FileText,
          title: "International Tax Advisory",
          description: "Optimizing global tax efficiency",
          points: [
            "Cross-border tax structuring and optimization",
            "DTAA and withholding tax advisory",
            "Advisory on foreign income, assets, and reporting requirements",
            "Exit tax and relocation tax planning"
          ],
          image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80"
        },
        {
          icon: Shield,
          title: "Global Regulatory & Compliance Advisory",
          description: "Navigating international regulatory frameworks",
          points: [
            "FEMA / exchange control advisory (where applicable)",
            "CRS / FATCA compliance advisory",
            "Substance and economic presence compliance advisory",
            "Ongoing regulatory and disclosure support"
          ],
          image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80"
        }
      ]
    },
    {
      id: "global-mobility",
      title: "Global Mobility & Residency Advisory",
      icon: Users2,
      heroImage: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80",
      subsections: [
        {
          icon: Globe2,
          title: "Global Mobility & Residency Planning",
          description: "Strategic relocation and citizenship advisory",
          points: [
            "Advisory on global mobility and residency planning",
            "Business and investor visa advisory (through partner firms)",
            "Relocation and expatriate tax planning",
            "Advisory on second residency and citizenship programs"
          ],
          image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80"
        }
      ]
    },
    {
      id: "risk-management",
      title: "Risk Management & Confidentiality Advisory",
      icon: Lock,
      heroImage: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80",
      subsections: [
        {
          icon: Lock,
          title: "Asset Protection & Risk Advisory",
          description: "Comprehensive risk mitigation and privacy solutions",
          points: [
            "Asset protection and risk mitigation structuring",
            "Confidentiality and privacy advisory",
            "Political, regulatory, and jurisdictional risk assessment",
            "Crisis and contingency planning advisory"
          ],
          image: "https://images.unsplash.com/photo-1582139329536-e7284fece509?w=800&q=80"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Advisory Services for High Net Worth Individuals & Family Offices
            </h1>
            <p className="text-xl md:text-2xl text-yellow-50 mb-4">
              Bespoke wealth, succession, and global structuring solutions
            </p>
            <p className="text-yellow-100 text-lg">
              Comprehensive advisory for sophisticated families and private clients across wealth management, 
              family office setup, overseas structuring, and global mobility
            </p>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
            Holistic, Confidential, and Globally Aligned
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            We serve HNIs, UHNW families, entrepreneurs, and professional family offices with end-to-end 
            advisory across wealth, tax, governance, and cross-border needs, working alongside specialist 
            law, tax, and fiduciary firms where execution is required.
          </p>
          <p className="text-gray-600">
            Our services are designed to preserve, grow, and transition wealth across generations while 
            maintaining privacy, regulatory compliance, and strategic flexibility.
          </p>
        </div>
      </section>

      {/* Render Each Section */}
      {sections.map((section, sectionIndex) => (
        <div key={section.id}>
          {/* Section Hero */}
          <section className={`py-16 ${sectionIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className={`grid lg:grid-cols-2 gap-8 items-center ${sectionIndex % 2 === 0 ? '' : 'lg:grid-flow-dense'}`}>
                <div className={sectionIndex % 2 === 0 ? '' : 'lg:col-start-2'}>
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-700 rounded-full text-sm font-semibold mb-4">
                    <section.icon className="w-4 h-4" />
                    <span>Service Area {sectionIndex + 1}</span>
                  </div>
                  <h2
                    className="text-3xl md:text-4xl font-bold mb-4 text-black"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {section.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6">
                    Specialized advisory services tailored to your unique needs and objectives.
                  </p>
                  <div className="flex gap-4">
                    <a
                      href="/contact"
                      className="px-6 py-3 bg-yellow-600 text-white font-semibold rounded-lg hover:bg-yellow-700 transition-all duration-300"
                    >
                      Schedule Consultation
                    </a>
                  </div>
                </div>
                <div className={`rounded-2xl overflow-hidden shadow-2xl ${sectionIndex % 2 === 0 ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
                  <img
                    src={section.heroImage}
                    alt={section.title}
                    className="w-full h-96 object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Subsections */}
          <section className={`py-16 ${sectionIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid md:grid-cols-2 gap-8">
                {section.subsections.map((subsection, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-500 group"
                  >
                    {/* Image */}
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={subsection.image}
                        alt={subsection.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute bottom-4 left-4 flex items-center gap-3">
                        <div className="p-3 bg-yellow-500 rounded-lg">
                          <subsection.icon className="w-6 h-6 text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-white">
                          {subsection.title}
                        </h3>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <p className="text-yellow-600 font-semibold text-sm mb-4">
                        {subsection.description}
                      </p>
                      <ul className="space-y-2">
                        {subsection.points.map((point, idx) => (
                          <li key={idx} className="flex items-start gap-2">
                            <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                            <span className="text-gray-600 text-sm leading-relaxed">
                              {point}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      ))}

      {/* Why Choose Us */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
              Why Partner With Us?
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">25+</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Years Experience</h3>
              <p className="text-gray-600">Deep expertise in HNI and family office advisory</p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">₹23,000Cr+</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Assets Advised</h3>
              <p className="text-gray-600">Wealth under advisory management</p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">50+</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Jurisdictions</h3>
              <p className="text-gray-600">Global coverage for overseas structuring</p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">100%</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Confidential</h3>
              <p className="text-gray-600">Complete privacy and discretion assured</p>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-12 bg-black">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="flex items-start gap-4">
            <div className="mt-1">
              <Shield className="w-7 h-7 text-yellow-500" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">
                Important Disclaimer
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed mb-2">
                All advisory services are provided in coordination with licensed legal, tax, and regulatory 
                professionals in the relevant jurisdictions. Investment execution, banking services, and 
                legal filings are handled by authorized entities including registered investment advisers, 
                regulated financial institutions, and admitted legal practitioners.
              </p>
              <p className="text-sm text-gray-400">
                This content is for informational and educational purposes and should not be treated as 
                independent legal, tax, or investment advice. Clients are encouraged to seek personalized 
                advice from appropriately qualified professionals before making any decisions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Explore a Bespoke Advisory Engagement
          </h2>
          <p className="text-lg text-yellow-50 mb-8">
            Discuss a customized mandate across wealth, family office, and cross-border requirements 
            under a confidential engagement model.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg"
            >
              Schedule a Private Consultation
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            <a
              href="tel:+919999999999"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-yellow-600 transition-all duration-300"
            >
              Call Advisory Desk
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
